import A11yMenu from './_a11yMenu';
import Swiper from 'swiper';
import {
	Navigation, A11y, Autoplay,
} from 'swiper/modules';

const initMultiBlocksSlider = () => {
	const sliders = document.querySelectorAll('.multiblocks-swiper');
	sliders.forEach((elt) => {
		const nbCols = elt.getAttribute('data-tabCols');
		const swiper = new Swiper(elt, {
			modules: [Navigation, A11y],
			slidesPerView: 1,
			spaceBetween: 36,
			enabled: true,
			init: false,
			watchOverflow: false,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
				prevSlideMessage: 'élément précédent',
				nextSlideMessage: 'élément suivant',
			},
			navigation: {
				nextEl: elt.querySelector('.swp-button-next'),
				prevEl: elt.querySelector('.swp-button-prev'),
				clickable: true,
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
					enabled: true,
				},
				720: {
					slidesPerView: nbCols,
					enabled: true,
				},
				960: {
					enabled: false,
				},
			},
		});

		swiper.on('breakpoint', (swipe, breakpointParams) => {
			if (!breakpointParams.enabled) {
				swipe.el.classList.add('disabled');
			} else {
				swipe.el.classList.remove('disabled');
			}
		});
		swiper.init();
	});
};

const initMarqueeSlider = () => {
	const sliders = document.querySelectorAll('.marquee-swiper');
	sliders.forEach((elt) => {
		const swiper = new Swiper(elt, {
			modules: [Autoplay],
			init: false,
			speed: 6000,
			autoplay: {
				delay: 1,
			},
			loop: true,
			slidesPerView: 'auto',
			allowTouchMove: false,
			disableOnInteraction: true,
			spaceBetween: 10,
		});
		swiper.init();
	});
};

const initTestimonialSlider = () => {
	const sliders = document.querySelectorAll('.testimonials-swiper');
	sliders.forEach((elt) => {
		let ifLoopBig = false;
		let ifRewindBig = true;

		if (elt.dataset.nb === 1) {
			ifLoopBig = true;
			ifRewindBig = false;
		}

		const swiper = new Swiper(elt, {
			modules: [Navigation, A11y],
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 40,
			loop: true,
			init: false,
			autoHeight: true,
			grabCursor: true,
			a11y: {
				enabled: true,
				containerRoleDescriptionMessage: 'carousel',
				itemRoleDescriptionMessage: 'slide',
				scrollOnFocus: true,
				wrapperLiveRegion: false,
				prevSlideMessage: 'élément précédent',
				nextSlideMessage: 'élément suivant',
			},
			navigation: {
				nextEl: elt.closest('.wp-block-smblocks-commentaires').querySelector('.swp-button-next'),
				prevEl: elt.closest('.wp-block-smblocks-commentaires').querySelector('.swp-button-prev'),
				clickable: true,
			},
			breakpoints: {
				1024: {
					loop: ifLoopBig,
					rewind: ifRewindBig,
					slidesPerView: elt.dataset.nb,
					slidesPerGroup: elt.dataset.nb,
				},
			},
		});
		swiper.init();
	});
};

document.addEventListener('DOMContentLoaded', () => {
	const menu = new A11yMenu(document.querySelector('.a11y-nav-block'), '61rem');
	menu.menuSetup();

	initMultiBlocksSlider();
	initTestimonialSlider();
	initMarqueeSlider();

	const tooltips = document.querySelectorAll('.linkTooltip');
	if (tooltips) {
		tooltips.forEach((tooltip) => {
			const tooltipsParent = tooltip.closest(`a[target='_blank']`);
			tooltipsParent.addEventListener('mouseenter', () => {
				tooltip.classList.add('visible');
			});

			tooltipsParent.addEventListener('focus', () => {
				tooltip.classList.add('visible');
			});

			tooltipsParent.addEventListener('blur', () => {
				tooltip.classList.remove('visible');
			});

			tooltipsParent.addEventListener('mouseleave', () => {
				tooltip.classList.remove('visible');
			});
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				tooltips.forEach((elt) => {
					if (elt.classList.contains('visible')) {
						elt.classList.remove('visible');
					}
				});
			}
		});
	}
});
